import dayjs from "dayjs";
import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { ReturnScalledImg } from "../helper";
import { Config } from "../config";

function OfferCard({ item }) {
  return (
    <Link to={`${Config.brochure_route}?id=${item.offer_id}`}>
      <div className="px-2 py-4 bg-white rounded-lg cursor-pointer sm:px-4 md:px-6 shadow-offer-card">
        <div className="mb-4 md:mb-6 sm:h-[200px] text-center">
          <LazyLoadImage
            className="max-h-[90px] sm:max-h-[200px] mx-auto"
            src={ReturnScalledImg(item.image)}
            alt={item.title}
            loading="lazy"
            effect="blur"
            delayMethod={"debounce"}
          />
        </div>
        <div className="mb-6 md:mb-10">
          <h2 className="h-10 mb-2 overflow-hidden text-sm font-bold line-clamp-2 text-primary">{item.title}</h2>

          <p className="text-xs text-opacity-50 sm:text-sm text-dark h-4">
            {item.end_date ? "Gültig bis: " + dayjs(item.end_date).format("DD.MM.YYYY") : ""}
          </p>
        </div>
        <button className="inline-flex items-center justify-center w-full max-w-full px-4 py-2 text-xs font-bold text-white uppercase transition-all duration-300 rounded-md sm:text-sm bg-primary drop-shadow-btn-primary hover:shadow-btn-primary-hover">
          ZUM PROSPEKT
        </button>
      </div>
    </Link>
  );
}

export default OfferCard;
